import { fileNameFromPath } from '@utils/strings';

import { FileCellEntry } from './types';

export type FileCellSummary =
  | { kind: 'empty' }
  | { kind: 'single'; name: string }
  | { kind: 'many'; count: number };

// A file cell reads as one line of text: the name of the file when there is
// exactly one, a count from two up - a column is never wide enough for two
// names, and the count carries the same information.
export const getFileCellSummary = (files: Array<FileCellEntry> | undefined): FileCellSummary => {
  const list = Array.isArray(files) ? files : [];

  if (list.length === 0) {
    return { kind: 'empty' };
  }

  if (list.length === 1) {
    return { kind: 'single', name: list[0].name || fileNameFromPath(list[0].src ?? '') };
  }

  return { kind: 'many', count: list.length };
};

// A single-file column has nowhere to put a second file, so its dropzone only
// appears once the file that is there has been removed.
export const getIsFileDropzoneVisible = ({
  isMulti,
  fileCount,
}: {
  isMulti: boolean;
  fileCount: number;
}): boolean => isMulti || fileCount === 0;
